import { toast } from "react-toastify";
import extracerForValidations from "../extractors/extracerForValidations";
import getFieldAddressAfterIndex from "../extractors/getFieldAddressAfterIndex";
import validate from "./validateV2";

const keepValidating = ({ formIsValid, data, cleanAddressForExtracer, validateAttributes, tttt }) => {
  if (tttt === "tttt") {
    // console.log("data", data);
    // console.log("cleanAddressForExtracer", cleanAddressForExtracer);
    // console.log("validateAttributes", validateAttributes);
  }
  if (cleanAddressForExtracer) {
    if (Array.isArray(cleanAddressForExtracer)) {
      for (const eachCleanAddressForExtracer of cleanAddressForExtracer) {
        const {
          value: extractedData,
          isComplete,
          processedPath,
        } = extracerForValidations(data, eachCleanAddressForExtracer);

        if (Array.isArray(extractedData) && !isComplete) {
          for (let i = 0; i < extractedData.length; i++) {
            const fieldIsValid = keepValidating({
              data: extractedData[i],
              cleanAddressForExtracer: getFieldAddressAfterIndex(eachCleanAddressForExtracer, 0),
              validateAttributes,
              tttt,
            });
            if (fieldIsValid === false) {
              // formIsValid = false;
              return false;
            }
          }
        } else if (Array.isArray(extractedData) && isComplete) {
          let validateOptions = {
            data: extractedData,
            ...validateAttributes,
          };
          validateOptions.type = "atLeastOneItemEvenEmpty";
          const validateRes = validate(validateOptions);
          if (!validateRes?.isValid) {
            // formIsValid = false;
            console.log(
              "false validation founded , only the first one is:",
              "at : ",
              cleanAddressForExtracer,
              "and eachCleanAddressForExtracer",
              eachCleanAddressForExtracer,
              "validateRes : ",
              validateRes,
              "extractedData",
              extractedData,
              "validateAttributes",
              validateAttributes
            );
            return false;
          }
        } else {
          const validateRes = validate({
            data: extractedData,
            ...validateAttributes,
          });
          if (!validateRes?.isValid) {
            // formIsValid = false;
            console.log(
              "false validation founded , only the first one is:",
              "at : ",
              cleanAddressForExtracer,
              "and eachCleanAddressForExtracer",
              eachCleanAddressForExtracer,
              "validateRes : ",
              validateRes,
              "extractedData",
              extractedData,
              "validateAttributes",
              validateAttributes
            );
            return false;
          }
        }
      }
    } else {
      const {
        value: extractedData,
        isComplete,
        processedPath,
      } = extracerForValidations(data, cleanAddressForExtracer);
      if (tttt === "tttt") {
        // console.log("extractedData", extractedData);
        // console.log("isComplete", isComplete);
      }
      if (Array.isArray(extractedData) && !isComplete) {
        for (let i = 0; i < extractedData.length; i++) {
          const fieldIsValid = keepValidating({
            data: extractedData[i],
            cleanAddressForExtracer: getFieldAddressAfterIndex(cleanAddressForExtracer, 0),
            validateAttributes,
            tttt,
          });
          if (fieldIsValid === false) {
            // formIsValid = false;
            return false;
          }
        }
      } else if (Array.isArray(extractedData) && isComplete) {
        let validateOptions = {
          data: extractedData,
          ...validateAttributes,
        };
        validateOptions.type = "atLeastOneItemEvenEmpty";
        const validateRes = validate(validateOptions);
        if (!validateRes?.isValid) {
          // formIsValid = false;
          console.log(
            "false validation founded , only the first one is:",
            "at : ",
            cleanAddressForExtracer,
            "validateRes : ",
            validateRes,
            "extractedData",
            extractedData,
            "validateAttributes",
            validateAttributes
          );
          return false;
        }
      } else {
        const validateRes = validate({
          data: extractedData,
          ...validateAttributes,
        });
        if (!validateRes?.isValid) {
          // formIsValid = false;
          console.log(
            "false validation founded , only the first one is:",
            "at : ",
            cleanAddressForExtracer,
            "validateRes : ",
            validateRes,
            "extractedData",
            extractedData,
            "validateAttributes",
            validateAttributes
          );
          return false;
        }
      }
    }
  } else {
    toast.error("Report this to PNG , cleanAddressForExtracer not founded", {
      toastId: "cleanAddressForExtracer",
    });
  }
};

export default keepValidating;
